import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import * as MockHook from '../../../src/util/useMockHook';
import useExpandableTextLogic, {
  ExpandableTextComponentProps,
  DEFAULT_LINE_HEIGHT,
} from './useExpandableTextLogic';

const DEFAULT_EXPAND_TEXT = 'Read more';
const DEFAULT_COLLAPSE_TEXT = 'Show less';

const useStyles = (
  props: Pick<
    ExpandableTextComponentProps,
    'maxLines' | 'lineHeight' | 'hasOverflow' | 'isExpanded'
  >
) =>
  makeStyles((theme: JupiterTheme) => {
    const {
      hasOverflow,
      isExpanded,
      maxLines,
      lineHeight = DEFAULT_LINE_HEIGHT,
    } = props;
    const useCollapsedStyles = hasOverflow && !isExpanded;
    return createStyles({
      text: {
        width: '100%',
        overflow: 'hidden',
        maxHeight: useCollapsedStyles ? `${maxLines * lineHeight}px` : 'none',
      },
      expandLink: {
        cursor: 'pointer',
        color: theme.palette.primary.main,
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    });
  });

export const ExpandableTextComponent = ({
  id,
  text,
  maxLines,
  isExpanded,
  className,
  lineHeight,
  hasOverflow,
  expandText = DEFAULT_EXPAND_TEXT,
  collapseText = DEFAULT_COLLAPSE_TEXT,
  toggleExpand,
}: ExpandableTextComponentProps) => {
  const classes = useStyles({
    hasOverflow,
    isExpanded,
    maxLines,
    lineHeight,
  })();

  return (
    <>
      <Typography id={id} className={clsx(classes.text, className)}>
        {text}
      </Typography>
      {hasOverflow && (
        <>
          {' '}
          <div className={classes.expandLink} onClick={toggleExpand}>
            {isExpanded ? collapseText : expandText}
          </div>
        </>
      )}
    </>
  );
};

export default MockHook.withHookHoc(
  ExpandableTextComponent,
  useExpandableTextLogic
);
